import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GetCollectionService } from '../services/get-collection.service';
import * as XLSX from 'xlsx';
import { Teacher } from '../model/teacher';
import { CreateTeacherComponent } from '../create-teacher/create-teacher.component';


@Component({
  selector: 'app-teacher',
  templateUrl: './teacher.component.html',
  styleUrls: ['./teacher.component.css']
})
export class TeacherComponent implements OnInit {
  teachers: Teacher[];
  displayedColumns = [ 'Image','TeacherName','TeacherAge','TeacherAddress','mobile','Qualification','DOJ','Experience','Gender','DOB','Action'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: MatTableDataSource<Teacher>;
  @ViewChild('TABLE') table: ElementRef;
  
  constructor(public dialog: MatDialog,private crudService: GetCollectionService) {
    this.crudService.read_Students('Teachers').subscribe((data) => {
      this.teachers = data.map((e) => {
        return {
          id: e.payload.doc.id,
          ...(e.payload.doc.data() as Teacher),
        } as Teacher;
      });
      //console.log(this.teachers);
     this.dataSource = new MatTableDataSource(this.teachers);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
    });
   }

  
  
  openDialog(): void {
    const dialogRef = this.dialog.open(CreateTeacherComponent, {
      width: '500px',
      disableClose: true
    });

    

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('The dialog was closed');
      
    // });
    
  }

  exportAsExcel()
    {
      console.log(this.table);
      const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);//converts a DOM TABLE element to a worksheet
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      XLSX.writeFile(wb, 'Students.xlsx');

    }

     getFileName = (name: string) => {
      let timeSpan = new Date().toISOString();
      let sheetName = name || "ExportResult";
      let fileName = `${sheetName}-${timeSpan}`;
      return {
        sheetName,
        fileName
      };
    };
    exportTableToExcel(tableId: string="ExampleMaterialTable", name: string="StudentsTable") {
      let { sheetName, fileName } = this.getFileName(name);
      let targetTableElm = document.getElementById(tableId);
      let wb = XLSX.utils.table_to_book(targetTableElm, <XLSX.Table2SheetOpts>{
        sheet: sheetName
      });
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    }
  
    exportArrayToExcel(name: string="Students") {
      let { sheetName, fileName } = this.getFileName(name);
  
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(this.teachers);
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    }

  editStudent(row:any){
    const dialogRef = this.dialog.open(CreateTeacherComponent, {
      width: '500px',
      data: row,
      disableClose: true
    });
  }

  deleteStudent(row:any){
    this.crudService.delete_Student('Teachers',row.id);
  }


  ngOnInit(): void {
    

  }

  // ngAfterViewInit() {
   
  //     this.dataSource.paginator = this.paginator;
  //     this.dataSource.sort = this.sort;
   
   
  // }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  

}
